import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LINKS = [
  { to: "/projects", label: "Projects", testid: "nav-link-projects" },
  { to: "/services", label: "Services", testid: "nav-link-services" },
  { to: "/about", label: "About", testid: "nav-link-about" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <>
      <header
        className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 border-b ${
          scrolled ? "bg-[#F8F6F0]/85 backdrop-blur-xl border-black/5" : "bg-transparent border-transparent"
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-6 sm:px-10 h-16 sm:h-20 flex items-center justify-between">
          <Link to="/" data-testid="nav-brand-logo" className="leading-none">
            <span className="font-cursive text-2xl sm:text-[1.75rem] tracking-wide text-[#181816]">Space Arts</span>
            <span className="font-cursive text-xl sm:text-2xl text-[#181816] ml-2 align-middle leading-none">by AK</span>
          </Link>

          <nav className="hidden md:flex items-center gap-9">
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                className={`link-underline font-mono text-[11px] uppercase tracking-[0.22em] transition-colors ${
                  pathname.startsWith(l.to) ? "text-[#181816]" : "text-[#57534E] hover:text-[#181816]"
                }`}
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/admin"
              data-testid="nav-link-admin"
              className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#8A857D] hover:text-[#181816] transition-colors"
            >
              Studio
            </Link>
            <Link
              to="/contact"
              data-testid="nav-cta-inquire"
              className="group inline-flex items-center gap-2 bg-[#181816] text-[#F8F6F0] pl-5 pr-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.22em] hover:bg-[#B85D3B] transition-colors duration-300"
            >
              Inquire
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </nav>

          <button
            className="md:hidden p-2 -mr-2"
            data-testid="nav-menu-toggle"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </header>

      {open && (
        <div className="fixed inset-0 z-40 bg-[#F8F6F0] pt-24 px-6 md:hidden">
          <nav className="flex flex-col gap-2">
            {LINKS.map((l, i) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`mobile-${l.testid}`}
                className="font-serif text-4xl py-3 border-b hairline"
              >
                <span className="font-mono text-xs text-[#C29B38] mr-4 align-middle">0{i + 1}</span>
                {l.label}
              </Link>
            ))}
            <Link to="/admin" data-testid="mobile-nav-link-admin" className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#8A857D] py-4">
              Studio Login
            </Link>
          </nav>
        </div>
      )}
    </>
  );
}
